import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { List } from 'immutable';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import { ChartsService } from '../../services/charts.service';
import { Router } from '@angular/router';

// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import 'chart.piecelabel.js';

import { ChartConfiguration,ChartType, ChartTypeRegistry } from 'chart.js';

interface IRow {
  timestamp: string;
  numOfClients: number;
  numOfNewClients: number;
  newClientsPercentage: number;
}
interface primeNgCol {
  field: string;
  header: string;
}

interface IRetentionTable {
  totalNewClients: number;
  newClientsReturned: number;
  newClientsPercentage: number;

  totalExistingClients: number;
  existingClientsReturned: number;
  existingClientsPercentage: number;

  overallTotal: number;
  overallReturned: number;
  overallReturnedPercentage: number;
}
interface iChartTypeRegistry {
  bar: string;
  line: string;
  pie: string;
}
@Component({
  selector: 'app-client-report',
  templateUrl: './client-report.page.html',
  styleUrls: ['./client-report.page.scss'],
})
export class ClientReportPage implements OnInit {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IRow>;

  public export: any[];

  public cols: primeNgCol[];

  public columns: any[];

  public stylistID: number;

  public stylist: Stylist;

  public xAxisDateChanger: string;

  public yearIndicator: boolean = false;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public groupBy: string;

  public pieChartColorRetention: Array<any>;

  public tab: string = 'totals';

  public lineChartLabels: Array<string> = [];

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: this.lineChartLabels,
    datasets: [
      {
        data: [],
        label: 'New Clients',
        backgroundColor: 'rgba(203, 123, 66, 0.2)',
        borderColor: 'rgba(203, 123, 66, 1)',
        tension: 0.5,
      },
    ],
  };

  private readonly tooltipCallbacks: object;

  public clientTotalsChartLabels: string[] = ['New', 'Existing'];

  public clientTotalsChartData: ChartConfiguration<'pie'>['data'] = {
    labels: this.clientTotalsChartLabels,
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#CB7B42', '#DCBF53'],
        borderColor: ['#333', '#333'],
      },
    ],
  };

  public ChartType: keyof iChartTypeRegistry = 'pie'; 

  public yearTotalWeekData: any[] = [];

  public lineChartLegend: boolean = true;

  public lineChartType: keyof iChartTypeRegistry = 'line'; 

  // public lineChartOptions: any;

  // values for the retention
  public retentionNewClientsChartData: ChartConfiguration<'pie'>['data'] = {
    labels: ['Didnt return', 'Returned'],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#EC6B56', '#FFC154'],
        borderColor: ['#333', '#333'],
      },
    ],
  };

  public retentionExistingClientsChartData: ChartConfiguration<'pie'>['data'] =
    {
      labels: ['Didnt return', 'Returned'],
      datasets: [
        {
          data: [0, 0],
          backgroundColor: ['#EC6B56', '#FFC154'],
          borderColor: ['#333', '#333'],
        },
      ],
    };

  public retentionOverallChartData: ChartConfiguration<'pie'>['data'] = {
    labels: ['Didnt return', 'Returned'],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#EC6B56', '#FFC154'],
        borderColor: ['#333', '#333'],
      },
    ],
  };

  public retentionTable: IRetentionTable;

  public retentionChartOptions: ChartConfiguration<'pie'>['options'];
  constructor(
    //public navCtrl: NavController,
    // public navParams: NavParams,
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private CalendarService: CalendarService,
    private ChartsService: ChartsService,
    private router: Router // , // private googleAnalytics: GoogleAnalytics
  ) {
    this.stats = [];
    this.cols = [
      { field: 'timestamp', header: 'Date' },
      { field: 'numOfClients', header: '# Clients' },
      { field: 'numOfNewClients', header: '# New Clients' },
      { field: 'newClientsPercentage', header: '% New Clients' },
    ];

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (
        user.isAdministrator() ||
        user.getCanViewReports() === 1 ||
        user.getViewAllClients() === 1
      ) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }
    this.tooltipCallbacks = ChartsService.tooltipCallbackFunction(
      this.yearTotalWeekData
    );

    // this.lineChartOptions = ChartsService.lineChartOption(
    //   this.yearTotalWeekData,
    //   this.xAxisDateChanger
    // );
  }


  public ngOnInit() {
    // this.googleAnalytics.trackView('ClientReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.groupBy) {
      let dateFromCache: string = localStorage.getItem('groupBy');

      if (dateFromCache) {
        this.groupBy = dateFromCache;
      } else {
        this.groupBy = 'daily';
      }
    }
  }
  public ngAfterViewInit() {
    if (this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.groupBy = dateRange.groupBy;

    this.timeManager(dateRange.start, dateRange.end, this.groupBy);
    this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
  }

  public onTabChange() {
    if (this.tab === 'totals') {
      this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
    } else if (this.tab === 'retention') {
      this.loadRetention(this.stylist);
    }
  }

  public loadStats(
    stylist: Stylist,
    startDate: Date,
    endDate: Date,
    groupBy: string = 'daily'
  ) {
    this.timeManager(startDate, endDate, groupBy);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.clientTotalsChartData.datasets[0].data = [];
    this.reportService
      .loadClientsStats(stylist.id, startDate, endDate, groupBy)
      .subscribe({
        next: (rows) => {
          const stats: Array<IRow> = [];

          let lineChartNewClients: Array<number> = [];
          let lineChartLabels: Array<string> = [];

          let totalClients: number = 0;
          let totalNewClients: number = 0;

          let existingClientsPercentage: number = 0;
          let newClientsPercentage: number = 0;

          rows.forEach((row) => {
            let newClientsPercentage = 0;

            if (row.numOfClients > 0) {
              newClientsPercentage = Math.round(
                (row.numOfNewClients / row.numOfClients) * 100
              );
            }

            let timestamp: string = '';

            if (this.groupBy === 'daily') {
              timestamp = Utilities.formatDate(
                Utilities.parseDate(row.timestamp),
                'ddd, MMMM D, Y'
              );
            } else if (this.groupBy === 'weekly') {
              timestamp = row.timestamp;
            } else if (this.groupBy === 'monthly') {
              timestamp = Utilities.formatDate(
                Utilities.parseDate(row.timestamp),
                'MMMM'
              );
            }

            stats.push({
              timestamp: timestamp,
              numOfClients: row.numOfClients,
              numOfNewClients: row.numOfNewClients,
              newClientsPercentage: Math.round(newClientsPercentage),
            });
            lineChartNewClients.unshift(row.numOfNewClients);
            lineChartLabels.unshift(timestamp);

            totalClients += row.numOfClients;
            totalNewClients += row.numOfNewClients;
          });

          lineChartLabels.reverse();
          lineChartNewClients.reverse();

          if (totalClients > 0) {
            newClientsPercentage = Math.round(
              (totalNewClients / totalClients) * 100
            );
            existingClientsPercentage = Math.round(100 - newClientsPercentage);
          }

          this.clientTotalsChartData.datasets[0].data = [
            newClientsPercentage,
            existingClientsPercentage,
          ];

          this.stats = stats;
          if (this.yearIndicator && groupBy === 'daily') {
            this.lineChartData.datasets[0].data = [];
            this.lineChartLabels = lineChartLabels.filter((label, i) => {
              return (i % 7 === 1 && i !== 1) || i === 0;
            });
            let dataSum: number = 0,
              count: number = 0;
            lineChartNewClients.forEach((val, i, array) => {
              if ((i !== 1 && i % 7 === 1) || i === array.length - 1) {
                this.lineChartData.datasets[0].data.push(
                  Number((dataSum / count).toFixed(2))
                );
                this.yearTotalWeekData.push({
                  sum: dataSum,
                  avg: Number((dataSum / count).toFixed(2)),
                });
                dataSum = 0;
                count = 0;
              } else {
                dataSum += val;
                count += 1;
              }
            });
          } else {
            this.yearTotalWeekData = [];
            this.lineChartLabels = lineChartLabels;
            this.lineChartData.datasets[0].data = lineChartNewClients;
            if (groupBy === 'weekly') {
              this.lineChartLabels = this.lineChartLabels.map((week) => {
                return week.substring(0, week.indexOf(' '));
              });
            } else if (groupBy === 'monthly') {
              this.lineChartLabels = this.lineChartLabels.map((month, i) => {
                return (
                  this.startDate.getFullYear() +
                  '-' +
                  ('0' + (i + 1)).slice(-2) +
                  '-' +
                  '01'
                );
              });
            }
          }

          this.lineChartData.labels = this.lineChartLabels;
          this.isLoading = false;
          //this.content.resize();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          //this.content.resize();
        },
      });
  }
  public timeManager(dateRangeStart, dateRangeEnd, groupBy) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;

    // this.lineChartOptions.scales.xAxes[0].time.unit = this.xAxisDateChanger;
    // this.lineChartOptions.scales.xAxes[0].time.displayFormats =
    //   ChartsService.timeDisplayFormat();
    // if (this.yearIndicator && groupBy === 'daily') {
    //   this.lineChartOptions.tooltips.callbacks = this.tooltipCallbacks;
    // } else {
    //   this.lineChartOptions.tooltips.callbacks = {};
    // }
  }

  public loadRetention(stylist: Stylist) {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;

    this.reportService.loadClientRetention(stylist.id).subscribe({
      next: (retention) => {
        this.retentionTable = {
          totalNewClients: retention.totalNewClients,
          newClientsReturned: retention.newClientsReturned,
          newClientsPercentage: 0,

          totalExistingClients: retention.totalExistingClients,
          existingClientsReturned: retention.existingClientsReturned,
          existingClientsPercentage: 0,

          overallTotal:
            retention.totalNewClients + retention.totalExistingClients,
          overallReturned:
            retention.newClientsReturned + retention.existingClientsReturned,
          overallReturnedPercentage: 0,
        };

        this.retentionTable.newClientsPercentage = Utilities.roundTo2Decimal(
          this.retentionTable.totalNewClients > 0
            ? (this.retentionTable.newClientsReturned /
                this.retentionTable.totalNewClients) *
                100
            : 0
        );
        this.retentionTable.existingClientsPercentage =
          Utilities.roundTo2Decimal(
            this.retentionTable.totalExistingClients > 0
              ? (this.retentionTable.existingClientsReturned /
                  this.retentionTable.totalExistingClients) *
                  100
              : 0
          );
        this.retentionTable.overallReturnedPercentage =
          Utilities.roundTo2Decimal(
            this.retentionTable.overallTotal > 0
              ? (this.retentionTable.overallReturned /
                  this.retentionTable.overallTotal) *
                  100
              : 0
          );

        this.retentionNewClientsChartData.datasets[0].data[1] =
          this.retentionTable.newClientsPercentage;
        this.retentionNewClientsChartData.datasets[0].data[0] =
          100 - this.retentionNewClientsChartData.datasets[0].data[1];

        this.retentionExistingClientsChartData.datasets[0].data[1] =
          this.retentionTable.existingClientsPercentage;
        this.retentionExistingClientsChartData.datasets[0].data[0] =
          100 - this.retentionExistingClientsChartData.datasets[0].data[1];

        this.retentionOverallChartData.datasets[0].data[1] =
          this.retentionTable.overallReturnedPercentage;
        this.retentionOverallChartData.datasets[0].data[0] =
          100 - this.retentionOverallChartData.datasets[0].data[1];

        this.isLoading = false;
        //this.content.resize();
      },
      error: (e) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingStats = true;
        //this.content.resize();
      },
    });
  }

  public summaryNumClients() {
    return this.stats
      .map((row) => row['numOfClients'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryNumNewClients() {
    return this.stats
      .map((row) => row['numOfNewClients'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryPercentNewClients() {
    let totalPercentNew: number = Math.round(
      (this.stats
        .map((row) => row['numOfNewClients'])
        .reduce((res, cell) => (res += cell), 0) /
        this.stats
          .map((row) => row['numOfClients'])
          .reduce((res, cell) => (res += cell), 0)) *
        100
    );
    return this.stats
      .map((row) => row['numOfClients'])
      .reduce((res, cell) => (res += cell), 0) > 0
      ? totalPercentNew
      : 0;
  }

  public exportPdf() {
    this.export = [
      ...this.stats,
      {
        timestamp: 'Total',
        numOfClients: this.summaryNumClients(),
        numOfNewClients: this.summaryNumNewClients(),
        newClientsPercentage: this.summaryPercentNewClients(),
      },
    ];
    this.ExportTableService.exportPdf(this.export, 'Clients', this.cols);
  }

  public exportExcel() {
    this.export = [
      ...this.stats,
      {
        timestamp: 'Total',
        numOfClients: this.summaryNumClients(),
        numOfNewClients: this.summaryNumNewClients(),
        newClientsPercentage: this.summaryPercentNewClients(),
      },
    ];
    this.ExportTableService.exportExcel(
      this.export,
      'Clients',
      this.cols.map((col) => col.header)
    );
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/reports');
  }
}
